import { useState } from 'react';
import { submitContactForm } from '../services/contactService';

export const useContactForm = () => {
  const [status, setStatus] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const submitForm = async (formData) => {
    setStatus('loading');
    setErrorMessage('');

    try {
      await submitContactForm(formData);
      setStatus('success');
      return { success: true };
    } catch (error) {
      setStatus('error');
      setErrorMessage(error.message || 'Failed to submit form. Please try again.');
      return { success: false, error: error.message };
    }
  };

  const reset = () => {
    setStatus('idle');
    setErrorMessage('');
  };

  return {
    status,
    errorMessage,
    submitForm,
    reset,
    isLoading: status === 'loading',
    isSuccess: status === 'success',
    isError: status === 'error'
  };
};